<template>
  <div class="container">
    <div style = "position: absolute;
    color: #ffffff;
    left: 2.5vh;
    top: -4vh;
    z-index: 999;
    font-size: calc(100vw * 14 / 1920);
    display: flex;
    align-items: center;
    cursor: pointer;"
         @click="goIndex()">
      <img
          class="label_1"
          referrerpolicy="no-referrer"
          src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngbab5f198dfc4bdb15571a116b3d9e4cde6067c4d38c292b039ea2618876a9b7d"
      />
      <span class="text_1">返回首页</span>
    </div>
    <div class="right-container">

      <div class="right-top">
            <div style="display: flex; height: 4.6vh;padding-bottom: 3vh;">
              <div class="query" v-bind:class=" card === 'Summary'?'light':''" @click="chooseCard('Summary')">汇总</div>
              <div class="query" v-bind:class=" card === 'Cun'?'light':''" @click="chooseCard('Cun')">村级</div>
              <div class="query" v-bind:class=" card === 'Company'?'light':''" @click="chooseCard('Company')" >公司单位</div>
              <div class="query" v-bind:class=" card === 'Ju'?'light':''" @click="chooseCard('Ju')">居委</div>
              <div class="query" v-bind:class=" card === 'guo'?'light':''" style=" width: 9vw;" @click="chooseCard('guo')">行政事业单位国有资产</div>
            </div>
      </div>

      <!--      汇总-->
      <Summary v-if="card === 'Summary'"
      @changeCard="changeCard"></Summary>
      <!--      村级-->
      <Cun v-if="card === 'Cun'"></Cun>
      <!--      公司-->
      <Company v-if="card === 'Company'"></Company>
      <!--      居委-->
      <Ju v-if="card === 'Ju'"></Ju>

      <Guo v-if="card === 'guo'"></Guo>


    </div>

  </div>

</template>

<script>
import { getTotalList, deleteUser, isSuperManager } from "@/api/Hosing";
import  Company  from "@/components/landCompany.vue";
import  Summary  from "@/components/landSummary.vue";
import  Cun  from "@/components/landCun.vue";
import  Ju  from "@/components/landJu.vue";
import  Guo  from "@/components/landGuo.vue";
export default {
  name: "userJurisdiction",
  data() {
    return {
      form: {
        nickName: "",
        userName: "", // 手机号
        etName:'', // 企业
      },
      totalList: [],
      currentPage: 1,
      pageSize: 15,
      total: 0,
      card:'Summary',
      cardLight:true,
      btn:0
    };
  },
  components:{
    Company,
    Summary,
    Cun,
    Ju,
    Guo
  },
  methods: {
    changeCard(e){
      if (e.classification=='村级'){
        this.card = 'Cun';
      }else if(e.classification=='公司单位'){
        this.card = 'Company';
      }else if(e.classification=='居委') {
        this.card = 'Ju';
      }else if(e.classification=='行政事业单位国有资产') {
        this.card = 'Guo';
      }else {
        return;
      }
      console.log(e,'e')
    },
    chooseCard(e){
      this.card = e;
      // let data;
      // if (e==='total'){
      //    data = 0;
      // }else if(e ==='cun'){
      //    data = 1;
      // }else if(e ==='company'){
      //    data = 2;
      // }else if(e ==='ju'){
      //    data = 3;
      // }else {
      //    data = 4;
      // }
      // getTotalList(data).then((res) => {
      //   console.log(res, "阿什杜阿虎");
      //   this.totalList = res.data;
      // });
    },
    chooseBtn(e){
      this.btn = e;
    },
    handleRowClick(row, column, event) {
      console.log(row); // 被点击的行数据对象，包含了行中的所有数据。可以在这里进行你需要的操作。例如：打印行数据。
      console.log(column); // 被点击的列数据对象，包含了列的属性信息。可以在这里进行你需要的操作。例如：打印列属性。
      console.log(event); // 原生的事件对象，包含了事件的一些信息。可以在这里进行你需要的操作。例如：阻止事件的默认行为。
      if (this.card !=='total'){
        this.$router.push({ path: '/housing', query: { id: row.id }});
      }
    },
    goIndex(){
      this.$router.push("/index");
    },
    headerStyle() {
      return "background:#0F2455;color:#fff;border: 1px solid #286AE8;text-align:center";
    },
    rowStyle() {
      return "background:#0F2455;color:#fff;border: 1px solid #286AE8;text-align:center";
    },
    getList() {
      getTotalList(0).then((res) => {
        console.log(res, "阿什杜阿虎");
        this.totalList = res.data;

      });
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.container::v-deep {
  margin-top: 2vh;
  width: 100%;
  position: relative;
  .left-title {
    position: absolute;
    left: 0;
    top: 0;
    background: url(@/assets/images/titleBg.png);
    background-size: 100% 100%;
    width: 11.1vw;
    height: 5.5vh;
    color: #fff;
    font-size: calc(100vw * 20 / 1920);
    text-align: center;
    line-height: 5.5vh;
    margin-right: 4vw;
  }
  .right-container {
    width: 81vw;
    position: absolute;
    left: 3vw;
    right: 0;
    margin: 0 auto;

    .right-top {

      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .el-form-item {
        display: flex;
        align-items: center;
        height: 4.6vh;

        .el-input__inner {
          width: 100%;
          height: 4.6vh;
          font-size: calc(100vw * 16 / 1920);
          box-shadow: inset 0rem 0rem 0.43rem 0.17rem rgba(44, 98, 230, 0.28);
          border-radius: 6px;
          border: 0.02rem solid #286ae8;
          background: none;
          color: #fff;
          &::placeholder {
            color: #fff;
          }
        }
        .el-form-item__label {
          width: 6.5vw;
          text-align: left;
          color: #fff;
          font-size: calc(100vw * 16 / 1920);
        }
      }
      .query,
      .reset {
        width: 8vw;
        height: 100%;
        background: url(@/assets/images/updown.png);
        background-size: 100% 100%;
        color: #02b5ff;
        font-size: calc(100vw * 16 / 1920);
        line-height: 4.6vh;
        text-align: center;
        cursor: pointer;
      }
      .query {
        margin-right: 1vw;
      }
    }
  }
}
::v-deep .el-form {
  width: 65vw;
  padding-left: 10vw;
  box-sizing: border-box;
}
::v-deep .el-table {
  width: 99.9%;
  margin-bottom: 2.5vh;
  font-size: calc(100vw * 16 / 1920);
}
::v-deep .el-table__body {
  font-size: calc(100vw * 14 / 1920);
}
::v-deep .el-table__row {
  height: 4vh;
}
.el-table--border::after,
.el-table--group::after,
.el-table::before {
  display: none;
}
::v-deep .el-pagination {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1vh;
}
::v-deep .el-pagination .el-select .el-input .el-input__inner,
::v-deep .el-pagination .btn-next,
::v-deep .el-pagination .btn-prev,
::v-deep .el-pager li,
::v-deep .el-pager li.btn-quicknext,
::v-deep .el-pager li.btn-quickprev,
::v-deep .el-pagination__total {
  //background: #0f2455;
  border-radius: 6px;
  border: 1px solid #286AE8;
  box-shadow: inset 0px 0px 20px 21px rgba(15,53,116,0.6);
  color: #fff;
  text-align: center;
}
::v-deep .el-pager li,
::v-deep .el-pagination .btn-next,
::v-deep .el-pagination .btn-prev {
  margin-right: 0.5vw;
}
::v-deep .el-pagination__total {
  margin-right: 0;
  padding: 0 0.8vw;
  box-sizing: border-box;
}
::v-deep .el-form-item__content {
  height: 4.6vh;
}
::v-deep .el-pager li.active {
  color: #409EFF;
}

.light{
  background: url(@/assets/use/btn3.png) !important;
  background-size: 100% 100% !important;
  color: #2EE6FE !important;

}
.lightBtn{
  background: url(@/assets/use/btn3.png) !important;
  background-size: 100% 100% !important;
  color: #2EE6FE !important;
  width: 12vw;
  height: 100%;
  background-size: 100% 100%;
  font-size: calc(100vw * 16 / 1920);
  line-height: 4.6vh;
  text-align: center;
  cursor: pointer;

}
.btn{
  background: url(@/assets/images/updown.png);
  background-size: 100% 100%;
  color: #02b5ff;
  width: 12vw;
  height: 100%;
  font-size: calc(100vw * 16 / 1920);
  line-height: 4.6vh;
  text-align: center;
  cursor: pointer;

}
</style>
